import PropTypes from 'prop-types';

const matchModel = () => {
  PropTypes.shape({
    params: {
      packageId: PropTypes.string
    }
  });
};

export default matchModel;
